import { useLocation, matchPath } from 'react-router-dom'
import Navigation from './Navigation'
import Footer from './Footer'
import SkipToContent from './SkipToContent'
import './Layout.css'

interface LayoutProps {
  children: React.ReactNode
}

const knownRoutes = ['/', '/about', '/services', '/careers', '/news', '/contact', '/news/:slug', '/gb/:city', '/uae/:city', '/sectors/:sector']

function Layout({ children }: LayoutProps) {
  const location = useLocation()
  
  const isKnownRoute = knownRoutes.some(route => 
    matchPath(route, location.pathname)
  )

  return (
    <div className="layout">
      <SkipToContent />
      <Navigation />
      <main id="main-content" className="main-content">
        {children}
      </main>
      {isKnownRoute && <Footer />}
    </div>
  )
}

export default Layout
